export default __webpack_public_path__ + "static/media/wealth_map_head_02_es.25251f69.png";